export default __webpack_public_path__ + "media/icons/line-a723a2a7.svg";